import { useNavigate } from 'react-router-dom';
import { DataGrid } from '@/components/data-grid';
import { ROUTES } from '@/app/routes';
import {
  useCoopModerationCases,
  useCoopModerationMetrics,
  type ProactiveCase,
} from '@/features/moderation/api';
import { proactiveColumns } from '@/features/moderation/columns';

/**
 * Content Management → Human Review.
 * Lists Coop cases escalated to TipMi ledger HUMAN_REVIEW (status=escalated).
 * Row opens content detail where moderators Approve / Reject.
 */
export function HumanReviewPage() {
  const navigate = useNavigate();
  const table = useCoopModerationCases('escalated');
  const metrics = useCoopModerationMetrics();
  const pending =
    metrics.data?.inHumanQueue ?? table.total ?? 0;

  return (
    <div className="flex h-full flex-col gap-4 p-4">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h1 className="text-lg font-semibold">Human Review</h1>
          <p className="mt-1 text-sm text-muted-foreground">
            Posts escalated by the moderation pipeline that need a human decision.
          </p>
        </div>
        <span className="rounded-md border bg-muted/40 px-3 py-1.5 text-sm text-muted-foreground">
          {pending} pending
        </span>
      </div>

      <div className="min-h-0 flex-1">
        <DataGrid<ProactiveCase>
          title="Human Review Queue"
          searchPlaceholder="Search human review queue…"
          columns={proactiveColumns}
          rows={table.rows}
          total={table.total}
          isLoading={table.isLoading}
          isFetchingNextPage={table.isFetchingNextPage}
          isError={table.isError}
          error={table.error}
          endReached={table.endReached}
          page={table.page}
          totalPage={table.totalPage}
          onPageChange={table.setPage}
          isFetching={table.isFetching}
          onLoadMore={table.fetchNextPage}
          onRetry={() => void table.refetch()}
          search={table.search}
          onSearchChange={table.setSearch}
          onRowClick={(row) => {
            if (row.post_id != null) {
              void navigate(ROUTES.contentDetails(String(row.post_id)));
            }
          }}
          getRowId={(row) => row.case_id}
          emptyMessage="No posts waiting for human review."
        />
      </div>
    </div>
  );
}
